<div class="dialog d-flex direction-column align-center manual-release-dialog" >
  <h2 class="dialog-title" mat-dialog-title>Liberação Manual do Sublote</h2>

  <mat-dialog-content>
    <p class="description">
      Ao informar os campos abaixo e enviar, todos os contratos desse sublote serão liberados manualmente sem realizar integração com OMIE.
    </p>

    <form [formGroup]="form">
      <div class="form-row">
        <div class="form-field">
          <app-c-input
            class="form-input dialog-field"
            label="Data de pagamento"
            formControlName="paymentDate"
            placeholder=""
            inputType="date"
            [required]="true"
          >
          </app-c-input>
          <mat-error *ngIf="form.get('paymentDate')?.hasError('required')" class="error-message">
            Data de pagamento é obrigatória
          </mat-error>
        </div>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Nº Pedido</mat-label>
          <input matInput
                 id="orderNumber"
                 formControlName="orderNumber"
                 (keypress)="onlyNumbers($event)">
          <mat-error *ngIf="form.get('orderNumber')?.hasError('required')">
            Número do pedido é obrigatório
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <div class="dialog-actions actions d-flex justify-center mt-36"
       mat-dialog-actions>
    
      <button class="actions-btn ui-btn ui-btn--primary" (click)="onSubmit()"
              [disabled]="form.invalid || submitting">
        <ng-container *ngIf="!submitting">Salvar</ng-container>
        <mat-spinner diameter="20" *ngIf="submitting"></mat-spinner>
      </button>
      <button class="actions-btn ui-btn ui-btn--secondary ml-16" (click)="onCancel()">Cancelar</button>
  </div>
</div>
